import { Skill } from "@/core/skills/types";
import { createInitialPetitionSkill } from "@/core/skills/implementations";
import { ActionId, Area, LegalPieceMacroType, LegalPieceMicroType, UploadingFile } from "@/contexts/MessagesContext";
import { Type } from "@sinclair/typebox";
import { DateTime } from "luxon";
import { v4 as uuidV4 } from "uuid";
import { base64ToFile } from "@/utils/base64ToFile";
import { fileToUploadingFile } from "@/utils/fileToUploadingFile";

const inputSchema = Type.Object({
  area: Type.String(),
  client: Type.String(),
  case_breakdown: Type.String(),
  theses: Type.Optional(Type.String()),
  evidence_text: Type.Optional(Type.String()),
  requests: Type.Optional(Type.String()),
  evidence_documents: Type.Optional(Type.Array(Type.String())),
});

const actionId = ActionId.CREATE_ONE_PIECE;

export const createLaborComplaintSkillV2 = {
  ...createInitialPetitionSkill,
  id: "create_labor_complaint_v2",
  name: "Escrever reclamação trabalhista",
  inputSchema,
  tags: ["litigation"],
  initialValue: {
    area: Area.LABOR,
  },
  flag: "skillCreateLaborComplaintV2Enabled",
  getMessage: (input) => {
    const evidence_documents: UploadingFile[] = [];

    input.evidence_documents?.forEach((evidenceDocument) => {
      if (evidenceDocument.startsWith("data:")) {
        evidence_documents.push(fileToUploadingFile(base64ToFile(evidenceDocument)));
      }
    });

    return {
      id: uuidV4(),
      type: "FLOW",
      direction: "SENT",
      author: "Current User",
      date: DateTime.now(),
      status: "READ",
      text: "Criar Reclamação Trabalhista",
      actions: [
        {
          id: actionId,
          text: "Criar Reclamação Trabalhista",
          client: input.client,
          legal_piece_macro_type: LegalPieceMacroType.INAUGURAL_DOCUMENT,
          legal_piece_micro_type: LegalPieceMicroType.INITIAL,
          area: input.area,
          case_breakdown: {
            source: "TEXT",
            text: input.case_breakdown,
          },
          theses: input.theses,
          evidence_text: input.evidence_text,
          requests: input.requests,
          reference_piece: null,
          evidence_documents: evidence_documents.map((evidenceDocument) => ({
            source: "FILE",
            file: evidenceDocument,
          })),
        },
      ],
      files: [...evidence_documents],
    };
  },
} satisfies Skill<typeof inputSchema>;
